import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/how-to-repay/gcash-step4.png")